<template>
	<div style="width:100%;height:100px;">
		<div class="logoNav">
			<!-- 左侧logo -->
			<img src="../../../assets/img/logo.gif" width="200" style="margin-top:30px;cursor: pointer;" @click="$router.push('/')">
			<!-- 右侧小图标 -->
			<img src="../../../assets/img/yjyHeadBg.jpg" style="position: absolute;right: 0;bottom: 0;" width="450">
		</div>
	</div>
</template>

<script>
</script>

<style scoped>
	/* logo及导航栏 */
	.logoNav {
		width: 1200px;
		height: 100px;
		margin: 0 auto;
		position: relative;
		bottom: 8px;
	}
</style>
